// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"632":"41066960cc96ecbfbc61","959":"fbc781207dd782c5d77c"}[chunkId] + ".js";
};